import { defaultTheme } from 'react-admin';
import { createTheme } from '@material-ui/core';
import merge from 'lodash.merge';

const theme = createTheme(
  merge({}, defaultTheme, {
    palette: {
      primary: {
        main: '#e21f26',
        contrastText: '#ffffff'
      }
    },
    overrides: {
      MuiCssBaseline: {
        '@global': {
          body: {
            margin: 0
          }
        }
      }
    }
  })
);

export default theme;
